// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__8L-Wz","icon":"style_icon__Z2vbs"};